const DetailPageSummaryItemsStyle = `
  grid-auto-flow: row;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(2, 1fr);
`;

export default DetailPageSummaryItemsStyle;
